module.exports = __webpack_public_path__ + "img/list.c1c9b213.png";